/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_EarringsInputs */

const en_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earrings`)
};

const es_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendientes`)
};

const fr_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boucles d'oreilles`)
};

const de_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohrringe`)
};

const ja_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イヤリング・ピアス`)
};

const zh_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`耳环`)
};

const ar_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقراط`)
};

const id_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anting`)
};

const it_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orecchini`)
};

const ru_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серьги`)
};

const pt_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brincos`)
};

const ko_val_earrings = /** @type {(inputs: Val_EarringsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`귀걸이`)
};

/**
* | output |
* | --- |
* | "Earrings" |
*
* @param {Val_EarringsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_earrings = /** @type {((inputs?: Val_EarringsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_EarringsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_earrings(inputs)
	if (locale === "es") return es_val_earrings(inputs)
	if (locale === "fr") return fr_val_earrings(inputs)
	if (locale === "de") return de_val_earrings(inputs)
	if (locale === "ja") return ja_val_earrings(inputs)
	if (locale === "zh") return zh_val_earrings(inputs)
	if (locale === "ar") return ar_val_earrings(inputs)
	if (locale === "id") return id_val_earrings(inputs)
	if (locale === "it") return it_val_earrings(inputs)
	if (locale === "ru") return ru_val_earrings(inputs)
	if (locale === "pt") return pt_val_earrings(inputs)
	return ko_val_earrings(inputs)
});